export default "__VITE_ASSET__DwD6T6Wo__"